import React from 'react';
import { Phone } from 'lucide-react';

const SideContactBar = () => {
    return (
        <div className="hidden sm:block fixed left-0 top-1/2 transform -translate-y-1/2 z-50">
            <div className="flex flex-col space-y-0">
                {/* WhatsApp Button */}
                <div className="group relative flex items-center">
                    <a
                        href="https://wa.me/918450903882"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-12 h-12 bg-green-500 text-white flex items-center justify-center shadow-lg hover:bg-green-600 transition-colors duration-300"
                        aria-label="Contact us on WhatsApp"
                    >
                        <img
                            src="https://cdn.cdnlogo.com/logos/w/29/whatsapp-icon.svg"
                            alt="WhatsApp"
                            className="w-6 h-6"
                        />
                    </a>
                    <div className="absolute left-full ml-2 bg-green-500 text-white px-4 py-2 rounded-r-md whitespace-nowrap opacity-0 -translate-x-3 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 shadow-lg">
                        Whatsapp Us
                    </div>
                </div>

                {/* Call Button */}
                <div className="group relative flex items-center">
                    <a
                        href="tel:+918450903882"
                        className="w-12 h-12 bg-red-500 text-white flex items-center justify-center shadow-lg hover:bg-red-600 transition-colors duration-300"
                        aria-label="Call us"
                    >
                        <Phone size={24} />
                    </a>
                    <div className="absolute left-full ml-2 bg-red-500 text-white px-4 py-2 rounded-r-md whitespace-nowrap opacity-0 -translate-x-3 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 shadow-lg">
                        Call Us
                    </div>
                </div>

                {/* Download App Button */}
                <div className="group relative flex items-center">
                    <a
                        href="https://play.google.com/store/apps/details?id=your.app.id"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-12 h-12 bg-gray-500 text-white flex items-center justify-center shadow-lg hover:bg-gray-600 transition-colors duration-300"
                        aria-label="Download our app"
                    >
                        <img
                            src={`https://www.google.com/s2/favicons?sz=64&domain_url=play.google.com`}
                            alt="Download"
                            className="w-6 h-6"
                        />
                    </a>
                    <div className="absolute left-full ml-2 bg-gray-500 text-white px-4 py-2 rounded-r-md whitespace-nowrap opacity-0 -translate-x-3 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 shadow-lg">
                        Download App
                    </div>
                    {/* <div className="absolute left-full ml-2 bg-white shadow-lg rounded-r-md overflow-hidden opacity-0 -translate-x-3 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
                        <div className="bg-green-500 text-white px-4 py-2 whitespace-nowrap">
                            Download App
                        </div>
                        <a
                            href="https://apps.apple.com/app/your-app-id"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block px-4 py-2 text-green-700 hover:bg-green-50 transition-colors flex items-center"
                        >
                            <img
                                src={`https://www.google.com/s2/favicons?sz=64&domain_url=appstoreconnect.apple.com`}
                                alt="App Store"
                                className="w-5 h-5 mr-2"
                            />
                            iOS App
                        </a>
                        <a
                            href="https://play.google.com/store/apps/details?id=your.app.id"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block px-4 py-2 text-green-700 hover:bg-green-50 transition-colors flex items-center"
                        >
                            <img
                                src={`https://www.google.com/s2/favicons?sz=64&domain_url=play.google.com`}
                                alt="Play Store"
                                className="w-5 h-5 mr-2"
                            />
                            Android App
                        </a>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default SideContactBar;